
import { AIPProjectReportModel, AIPReportActivitiesModel } from '../../../models/cbo/AIPDashboardReportModel';
import { AIPPortletsModel, IAIPDataPayload, IConfigValidateRequest, IConfigValidateResponse } from '../../../models/cbo/AIPPortletsModel';
import { IStoreAction } from '../../StoreHelper';

export enum AIPPortletsActionTypes {
  GET_AIP_STARTED = 'GET_AIP_STARTED',
  GET_AIP_SUCCESS = 'GET_AIP_SUCCESS',
  GET_AIP_ERROR = 'GET_AIP_ERROR',
  GET_AIP_PROJECTS_STATUS_STARTED = 'GET_AIP_PROJECTS_STATUS_STARTED',
  GET_AIP_PROJECTS_STATUS_SUCCESS = 'GET_AIP_PROJECTS_STATUS_SUCCESS',
  GET_AIP_PROJECTS_STATUS_ERROR = 'GET_AIP_PROJECTS_STATUS_ERROR',
  GET_AIP_PROJECTS_ACTIVITIES_STARTED = 'GET_AIP_PROJECTS_ACTIVITIES_STARTED',
  GET_AIP_PROJECTS_ACTIVITIES_SUCCESS = 'GET_AIP_PROJECTS_ACTIVITIES_SUCCESS',
  GET_AIP_PROJECTS_ACTIVITIES_ERROR = 'GET_AIP_PROJECTS_ACTIVITIES_ERROR',
  GET_CONFIG_VALIDATE_STARTED = 'GET_CONFIG_VALIDATE_STARTED',
  GET_CONFIG_VALIDATE_SUCCESS = 'GET_CONFIG_VALIDATE_SUCCESS',
  GET_CONFIG_VALIDATE_ERROR = 'GET_CONFIG_VALIDATE_ERROR',
}

export type AIPPortletsPayload =
  | string
  | Error
  | AIPPortletsModel[]
  | AIPProjectReportModel[]
  | AIPReportActivitiesModel[]
  | IConfigValidateResponse
  | IConfigValidateRequest
  | IAIPDataPayload

export type AIPPortletsAction = IStoreAction<
AIPPortletsActionTypes,
AIPPortletsPayload
>;

export class AIPPortletsActions {
  public static getAIPStarted(data: IAIPDataPayload): AIPPortletsAction {
    return {
      type: AIPPortletsActionTypes.GET_AIP_STARTED,
      data,
    };
  }

  public static getAIPSuccess(data: AIPPortletsModel[]): AIPPortletsAction {
    return {
      type: AIPPortletsActionTypes.GET_AIP_SUCCESS,
      data,
    };
  }

  public static getAIPError(error: Error): AIPPortletsAction {
    return {
      type: AIPPortletsActionTypes.GET_AIP_ERROR,
      data: error,
    };
  }
  public static getAIPProjectStatusStarted(): AIPPortletsAction {
    return {
      type: AIPPortletsActionTypes.GET_AIP_PROJECTS_STATUS_STARTED,
    };
  }

  public static getAIPProjectStatusSuccess(data: AIPProjectReportModel[]): AIPPortletsAction {
    return {
      type: AIPPortletsActionTypes.GET_AIP_PROJECTS_STATUS_SUCCESS,
      data,
    };
  }

  public static getAIPProjectStatusError(error: Error): AIPPortletsAction {
    return {
      type: AIPPortletsActionTypes.GET_AIP_PROJECTS_STATUS_ERROR,
      data: error,
    };
  }

  public static getAIPProjectActivitiesStarted(id: string): AIPPortletsAction {
    return {
      type: AIPPortletsActionTypes.GET_AIP_PROJECTS_ACTIVITIES_STARTED,
      data: id,
    };
  }
  public static getAIPProjectActivitiesSuccess(data: AIPReportActivitiesModel[]): AIPPortletsAction {
    return {
      type: AIPPortletsActionTypes.GET_AIP_PROJECTS_ACTIVITIES_SUCCESS,
      data,
    };
  }
  public static getAIPProjectActivitiesError(error: Error): AIPPortletsAction {
    return {
      type: AIPPortletsActionTypes.GET_AIP_PROJECTS_ACTIVITIES_ERROR,
      data: error,
    };
  }
  public static getConfigValidateStarted(data: IConfigValidateRequest): AIPPortletsAction {
    return {
      type: AIPPortletsActionTypes.GET_CONFIG_VALIDATE_STARTED,
      data: data,
    };
  }
  public static getConfigValidateSuccess(data: IConfigValidateResponse): AIPPortletsAction {
    return {
      type: AIPPortletsActionTypes.GET_CONFIG_VALIDATE_SUCCESS,
      data,
    };
  }
  public static getConfigValidateError(error: Error): AIPPortletsAction {
    return {
      type: AIPPortletsActionTypes.GET_CONFIG_VALIDATE_SUCCESS,
      data: error,
    };
  }
}
